import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import ScanQRCodeBanner from './ScanQRCodeBanner';

import { DescUploadImageStyled, ImageWrapperStyled } from './styles';

const NeedUploadBackSideImage = ({ forMobileOnly = false, isShowBanner = false }) => (
  <Stack
    aria-label="Need upload back side image"
    pb="64px"
  >
    <DescUploadImageStyled forMobileOnly={forMobileOnly}>
      {forMobileOnly ? (
        <Text
          color="tertiary"
          size="md"
        >
          Make sure “For Mobile Deposit Only” is clearly written under your signature on the back of
          the check:
        </Text>
      ) : (
        <Text
          color="tertiary"
          size="md"
        >
          Make sure your signature endorsement is clearly written on the back of the check.
        </Text>
      )}
    </DescUploadImageStyled>
    {isShowBanner && (
      <Box mb="40px">
        <ScanQRCodeBanner />
      </Box>
    )}
    <ImageWrapperStyled>
      <SharedAsset
        alt=""
        src="/s2/vector/back-of-check-example.svg"
      />
    </ImageWrapperStyled>
  </Stack>
);

NeedUploadBackSideImage.propTypes = {
  forMobileOnly: PropTypes.bool,
  isShowBanner: PropTypes.bool
};

export default NeedUploadBackSideImage;
